import React, { useEffect } from 'react'
import {
  CaptionText,
  IconButton,
  DislikeIcon,
  LikeIcon,
  PAYPAL_THEME,
  DislikeSelectedIcon,
  LikeSelectedIcon,
} from '@paypalcorp/pp-react'
//syles
import styles from './AiSearch.module.css'

const { sysColorBackgroundMediumContrast } = PAYPAL_THEME

const WasThisHelpful = ({
  searchQuery,
  answerId,
  searchID,
  setIsFeedbackOpen,
  setIsDislikeSelected,
  setIsLikeSelected,
  isLikeSelected,
  isDislikeSelected,
}: {
  searchQuery: string
  answerId: string
  searchID: string
  setIsFeedbackOpen: React.Dispatch<React.SetStateAction<boolean>>
  setIsDislikeSelected: React.Dispatch<React.SetStateAction<boolean>>
  setIsLikeSelected: React.Dispatch<React.SetStateAction<boolean>>
  isLikeSelected: boolean
  isDislikeSelected: boolean
}) => {
  const fptiData = typeof window !== `undefined` && window.fpti

  useEffect(() => {
    if (!isDislikeSelected) {
      setIsFeedbackOpen(false)
    }
  }, [isDislikeSelected])

  const onWasThisHelpfulClick = (isHelpful: boolean) => {
    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          tag: `was this helpful-${isHelpful}`,
          link: `gen-ai-summary|feedback|was this helpful-${isHelpful}|${answerId}`,
          component: 'devdiscoverynodeweb',
          query: searchQuery || '',
          searchID,
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    setIsFeedbackOpen(!isHelpful)
  }

  return (
    <>
      <span className={styles.wasHelpfulContainer}>
        <CaptionText
          className={styles.mr1}
          style={{ color: sysColorBackgroundMediumContrast }}
        >
          Was this helpful?
        </CaptionText>
        <IconButton
          buttonType="tertiary"
          size="xs"
          className={`${styles.thumbIcon} ${styles.mr1}`}
          svgIconComponent={isLikeSelected ? LikeSelectedIcon : LikeIcon}
          style={{ color: sysColorBackgroundMediumContrast }}
          onClick={() => {
            setIsLikeSelected((prev) => {
              setIsDislikeSelected(false)
              onWasThisHelpfulClick(true)
              return !prev
            })
          }}
        >
          helpful
        </IconButton>
        <IconButton
          buttonType="tertiary"
          size="xs"
          className={`${styles.thumbIcon} ${styles.thumbsDownIcon}`}
          svgIconComponent={
            isDislikeSelected ? DislikeSelectedIcon : DislikeIcon
          }
          style={{ color: sysColorBackgroundMediumContrast }}
          onClick={() => {
            setIsDislikeSelected((prev) => {
              setIsLikeSelected(false)
              onWasThisHelpfulClick(false)
              return !prev
            })
          }}
        >
          not helpful
        </IconButton>
      </span>
    </>
  )
}

export default WasThisHelpful
